declare global {
  interface Window {
    relevantID?: any;
  }
}

export const notAcceptedValues = ['undefined', '{}', 'neml_default'];

// Establish a function type for the callbacks provide within init() parameters.
export type fnCallback = (s?: any) => any;

/**
 * Set the payload sent as an object, merge with default config, and return it.
 * */
export class ConfigurationSettings {
  private _defaultConfig: DeviceConfiguration;

  /**
   * @description Initialize payload received.
   * @private
   */
  private initDefaultConfig(): void {
    this._defaultConfig = {
      rvidURL: '/prx/rvid',
      apiRvIdURL: process.env.DEVICE_RVID_URL,
      timeout: 7000,
      useCache: false,
      onlineId: null,
      profileId: null,
      profile: null,
      version: 1,
    };
  }

  /**
   *
   * @description original payload as a class property for easy manipulation.
   * @param config
   * @private
   */
  public setPayload(config: DeviceConfiguration | string): DeviceConfiguration {
    // Initialize payload and response
    this.initDefaultConfig();

    // Validates original payload.
    try {
      let tmpPayload = config;
      if (typeof tmpPayload == 'string') {
        tmpPayload = JSON.parse(tmpPayload);
      }
      this._defaultConfig = Object.assign(this._defaultConfig, tmpPayload);
    } catch (e) {
      return;
    }
    return this._defaultConfig;
  }
}

export interface DeviceProfile {
  idk?: string;
  ruleset?: string;
  rulesetAnon?: string;
  serviceId?: string;
  tenantId?: string;
  onlineIdType?: string;
}

export interface DeviceConfiguration {
  rvidURL?: string;
  apiRvIdURL?: string;
  timeout?: number;
  useCache?: boolean;
  onlineId?: number;
  profile?: DeviceProfile;
  profileId?: string;
  relevantId?: any;
  version?: 1 | 2;
}
